import moment from 'moment';

export function fechaActual() {
    return moment().format('YYYY-MM-DD');
}



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/comun/utils/fechaActual.ts